import React from 'react'
import Button from 'react-bootstrap/Button'



const CancelButton = (props)=>{
    return(
        <Button 
            className="model-cancel-button"
            variant="light"
            style={{
                border: '2px solid #979797'
            }}
            onClick={props.submit}>
                <span>
                    {props.title}
                </span>
        </Button>
    )
}

export default CancelButton